import { NotificationsRouteScreen } from '@/screens/notifications/notifications-route-screen';
export default NotificationsRouteScreen;
